import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const BottomNavBillingIcon = ({ primaryColor = '#6b0bca', textColor = '#414042', size, style, secondaryColor, ...rest }) => (
    <SvgIcon viewBox='0 0 16.83 19.42' style={size ? { ...style, fontSize: size, width: size, height: size } : style} {...rest}>
        <path
            fill={primaryColor}
            d='M7.49,11.61l-1.8-1.11c-.12-.07-.18-.21-.18-.34V3.65c0-.16.09-.3.21-.36L10.98.05c.12-.07.26-.07.37,0l5.29,3.25c.12.07.18.21.18.34v6.51c0,.15-.08.29-.21.35l-5.27,3.24c-.12.07-.26.07-.37,0l-.28-.17c-.05.08-.13.14-.23.16l-2.04.64.71.71,4.31-2.56c.15-.09.33-.06.44.07l1.15,1.23c.18.19.13.5-.08.62l-6.76,4.9c-.1.07-.23.09-.34.04l-3.31-1.31-1.27-.22c-.26.68-.88,1.14-1.58,1.14-.94,0-1.71-.82-1.71-1.82v-3.59c0-1,.77-1.82,1.71-1.82.73,0,1.38.5,1.62,1.23l2.5-1.35c.05-.03.11-.04.17-.04h1.5ZM10.77,12.71l.4.25,4.92-3.03V3.88L11.17.85l-4.92,3.03v6.06l2.72,1.67h1.43c.2,0,.37.18.37.39v.71h0ZM2.66,17.37l.02-3.46v-.33c0-.57-.43-1.03-.97-1.03s-.97.46-.97,1.03v3.59c0,.57.43,1.03.97,1.03.47,0,.87-.36.95-.84h0ZM3.41,17.08l1.3.23s.05.01.07.02l3.16,1.26,6.26-4.54-.64-.68-4.28,2.55c-.14.09-.32.08-.45-.05l-1.38-1.38c-.21-.21-.13-.58.15-.67l2.42-.76v-.67h-3.95l-2.66,1.43v3.25h0Z'
        />
        <text fill={textColor} fontFamily="'Heebo', sans-serif" fontSize='8.44' fontWeight='700' transform='translate(7.14 9.71)'>
            <tspan x='0' y='0'>
                ₪
            </tspan>
        </text>
    </SvgIcon>
);

export default BottomNavBillingIcon;
